import { SKIP_INSTITUTION_SELECTOR } from "@/common/auth-types";
import { loginRequest } from "@/common/login.service";
import { useAuthStore } from "@/stores";

export default async (to, from, next) => {
  if (to.query.directlyToUnilogin) {
    await loginRequest("login", to.query.redirectUrl ?? "/dictionary");
    return next(); // Silence warning, external redirect happens in loginRequest()
  }

  if (to.query?.state) {
    const { login } = useAuthStore();
    try {
      // Check for login
      const result = await login(to.query);
      const { user, redirectUrl } = result.data;

      // Check institution selector override (if redirected from Ordbogen)
      const skipInstitutionSelector = sessionStorage.getItem(SKIP_INSTITUTION_SELECTOR);
      if (skipInstitutionSelector) {
        // Clean up session storage - we only want this override to run once
        sessionStorage.removeItem(SKIP_INSTITUTION_SELECTOR);
      }

      if (skipInstitutionSelector === null && user.institutions.length > 1) {
        return next({
          name: "institutions",
          query: {
            redirectUrl: redirectUrl || "/dictionary"
          }
        });
      }

      if (redirectUrl) {
        return next(redirectUrl);
      }
    } catch (e) {
      // We let it gracefully error, this probably just means that the api call failed
    }
  }

  next();
};
